export const SET_HORIZONTAL_CATEGORIES_ORDER = 'SET_HORIZONTAL_CATEGORIES_ORDER';

export const setHorizontalCategoriesOrder = (horizontalCategoriesOrder: { id: string; label: string }) => ({
  type: SET_HORIZONTAL_CATEGORIES_ORDER,
  data: horizontalCategoriesOrder,
});
